import service from '@/config/axios'

// 获取 Collection 分类列表
const getCategoryList = () => {
  return service.get('/api/product/category/list')
}

// 获取产品列表（支持分页和分类筛选）
const getProductList = (params) => {
  return service.get('/api/product/list', { params })
}

// 获取产品详情
const getProductDetail = (productId) => {
  return service.get(`/api/product/${productId}`)
}

// 搜索产品
const searchProducts = (params) => {
  return service.get('/api/product/search', { params, rawResponse: true })
}

// 获取推荐产品
const getRecommendedProducts = (count = 4) => {
  return service.get('/api/product/recommended', { params: { count } })
}

// 获取分类详情（产品浏览页初始化数据）
const getCategoryDetail = (categoryId) => {
  return service.get('/api/product/category/detail', { params: { CategoryID: categoryId } })
}

export {
  getCategoryList,
  getProductList,
  getProductDetail,
  searchProducts,
  getRecommendedProducts,
  getCategoryDetail
}